export default "assets/images/icons/expedition-a33602b0.svg";